/**
 * Results API Layer - Collection
 * Initializes Tagalys ShopifyCollection SDK for collection template
 */

class ResultsAPICollection {
  constructor () {
    this.eventBus = window.theme.tagalys.results.eventBus
    this.hasSearchParams = window.location.search !== ''

    onTagalysReady(() => {
      if(window.theme.resultsConfig.enableShopifyCollections) {
        window.theme.tagalys.results.SDK  = this.initializeShopifyCollection()
        window.theme.tagalys.results.SDK.helpers.call()
      } else {
        this.initializeTagalysCollection()
      }
    })
  }

  /**
   * Extracts search parameters from URL for Tagalys API
   * @returns {Object} Object containing filters, sortOrder, and page
   */
    extractSearchParams () {
        const urlParams = new URLSearchParams(window.location.search)

        // Extract filters - format: filterName-value1,value2,value3
        const filters = {}
        const filterParams = urlParams.getAll('filter')
        filterParams.forEach(filterParam => {
          const filterSplit = filterParam.split('~')
          filterSplit.forEach(param => {
            const dashIndex = param.lastIndexOf('-')
            if (dashIndex !== -1) {
              const filterName = param.substring(0, dashIndex)
              const values = param.substring(dashIndex + 1).split(',')
              filters[filterName] = values
            }
          })
        })

        const page = parseInt(urlParams.get('page'), 10) || 1
        const sortOrder = urlParams.get('sort') || ''

        return {
          filters,
          sortOrder,
          page,
        }
      }



  initializeTagalysCollection () {
    const { filters, sortOrder, page } = this.extractSearchParams()
    window.theme.tagalys.results.SDK = Tagalys.APIConnector.Collection.new({
      params: {
        collectionId: this.collectionId,
        filters: {
          ...filters
        },
        sort: sortOrder,
        perPage: window.theme.resultsConfig.productsPerPage || 32,
        page: page || 1,
      },
      failover: this.initializeShopifyCollection.bind(this),
      onSuccess: response => {
        this.eventBus.publish('results:api:fetched:success', response)
      },
      onFailure: response => {
        console.error('Collection fetch failed', response)
      },
    })
    window.theme.tagalys.results.SDK.helpers.call()

    if(this.hasSearchParams) {
      this.eventBus.publish('results:api:initialized')
    }
  }

  initializeShopifyCollection () {
    return Tagalys.APIConnector.ShopifyCollection.new({
      params: {
        collectionId: this.collectionId,
        perPage: window.theme.resultsConfig.productsPerPage || 32,
      },
      onSuccess: response => {
        this.eventBus.publish('results:api:fetched:success', response)
      },
      onFailure: response => {
        console.error('Collection fetch failed for both Tagalys and Shopify', response)
      }
    });
  }

  get collectionId () {
    return document.querySelector('[data-collection-id]')?.dataset.collectionId
  }
}

window.theme.tagalys.results.apiLayer = new ResultsAPICollection()
